import { useState, useEffect } from "react";
import { getAvailableYears } from "@/lib/api";

const defaultYears = () =>
  Array.from({ length: 5 }, (_, i) => (new Date().getFullYear() - i).toString());

// Returns the list of years that actually have flight data (desc, strings),
// falling back to the last 5 years while loading.
export function useAvailableYears() {
  const [years, setYears] = useState(defaultYears());
  useEffect(() => {
    let mounted = true;
    getAvailableYears()
      .then((res) => {
        if (mounted && Array.isArray(res.data) && res.data.length) {
          setYears(res.data.map(String));
        }
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);
  return years;
}
